import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const FaceScanPreview = lazyWithPreload(
  () => import('./FaceScanPreview'),
)
